module.exports = __webpack_public_path__ + "ipetbooking/admin/img/notification_avatar.0cb67360.jpg";